import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router";
import styled from "styled-components";
import { batch, useSelector, useDispatch } from "react-redux";

import Popup from "../Popup";
import Toast from "../Toast";
import { fetchPartnerInfo } from "redux/slices/partner/partnerSlice";
import "utils/define";
import { getPartnerBranchName } from "utils/define";

import iconFlag from "assets/icons/icon_flag_blue.svg";
import iconNext from "assets/icons/icon_next_black.svg";
import iconUpDown from "assets/icons/up-down-arrow.svg";
import iconCheck from "assets/icons/icon_check_blue.svg";
import iconClose from "assets/icons/icon_close_thick_black.svg";
import iconPartner from "assets/image/default_partner_thumbnail.svg";
import { FoldIcon } from "components/@icons/FoldIcon";

export const Branch = ({
  isHome,
  isAll,
  color = "#26282b",
  hideFoldIcon = false,
  ...props
}) => {
  const popupRef = useRef();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const partnerInfo = useSelector((state) => state.partner);
  const [visible, setVisible] = useState(false);
  const [seqPartner, setSeqPartner] = useState(0);
  const [seqPartnerBranch, setSeqPartnerBranch] = useState(0);

  const NO_NAME = "(이름없음)";

  useEffect(() => {
    if (
      !isAll &&
      partnerInfo.branchUseYn == "Y" &&
      partnerInfo.seqPartnerBranch == 0
    ) {
      dispatch(
        fetchPartnerInfo({
          seqPartner: partnerInfo.beforeSeqPartner,
          seqPartnerBranch: partnerInfo.beforeSeqPartnerBranch,
        })
      );
    }
    setSeqPartner(partnerInfo.seqPartner || 0);
    setSeqPartnerBranch(partnerInfo.seqPartnerBranch || 0);
  }, [partnerInfo.seqPartner, partnerInfo.seqPartnerBranch]);

  useEffect(() => {
    return () => {
      setVisible(false);
    };
  }, []);

  const eventHandler = {
    open: () => {
      setVisible(true);
    },
    close: () => {
      popupRef.current.close();
    },
    render: (container) => {
      const middle = container.querySelector(".middle");
      if (middle) {
        const li = middle.querySelector("li.focus");
        if (li) {
          const half = middle.offsetHeight / 2;
          let offsetTop =
            li.getBoundingClientRect().top - middle.getBoundingClientRect().top;
          offsetTop = offsetTop - half + li.offsetHeight / 2;
          if (offsetTop < 0) offsetTop = 0;
          middle.scrollTop = offsetTop;
        }
      }
      /*
				const li = container.querySelector(".middle li.focus");
				if(li) li.scrollIntoView({block: "center"});
			 */
    },
    submit: () => {
      setVisible(false);
      if (props.onChange)
        props.onChange(props.name, [seqPartner, seqPartnerBranch]);
    },
    change: (seqPartner, seqPartnerBranch) => {
      const newPartnerInfo = (partnerInfo.partnerList || []).filter((item) => {
        return item.seqPartner == seqPartner;
      })[0];
      if (!newPartnerInfo) return;

      dispatch(
        fetchPartnerInfo({
          seqPartner: seqPartner,
          seqPartnerBranch: seqPartnerBranch,
          partnerName: newPartnerInfo.partnerName,
          branchName: getPartnerBranchName(
            partnerInfo,
            seqPartner,
            seqPartnerBranch
          ),
          branchUseYn: newPartnerInfo.branchUseYn,
          headquarterYn:
            newPartnerInfo.branchUseYn == "Y"
              ? newPartnerInfo.headOfficeManagerYn
              : "N",
          beforeSeqPartner: partnerInfo.seqPartner,
          beforeSeqPartnerBranch: partnerInfo.seqPartnerBranch,
        })
      );
      setVisible(false);
      Toast(`연동센터가 변경되었습니다`, "check", "76px");
    },
    setting: () => {
      navigate("/all/settings/maincenter");
    },
    drop: (event) => {
      event.currentTarget.parentNode.classList.toggle("focus");
    },
  };

  const getPartnerName = () => {
    const seqPartner = partnerInfo.seqPartner;
    const seqPartnerBranch = partnerInfo.seqPartnerBranch;
    const newPartnerInfo =
      (partnerInfo.partnerList || []).filter((item) => {
        return item.seqPartner == seqPartner;
      })[0] || {};

    const getBranchName = () => {
      if (newPartnerInfo.branchUseYn != "Y") return "";
      if (!seqPartnerBranch) return " : 전체";
      const branchInfo =
        (newPartnerInfo.partnerBranches || []).filter((item) => {
          return item.seqPartnerBranch == seqPartnerBranch;
        })[0] || {};
      return (
        " : " + (branchInfo.partnerName || branchInfo.branchName || NO_NAME)
      );
    };
    return seqPartner
      ? (newPartnerInfo.partnerName || NO_NAME) + getBranchName()
      : "센터 선택";
  };

  const render = () => {
    // 주 연동센터 확인
    const isMainCenter = (seqPartner, seqPartnerBranch) => {
      return (
        partnerInfo.mainSeqPartner == seqPartner &&
        partnerInfo.mainSeqPartnerBranch == seqPartnerBranch
      );
    };
    // 지점 목록
    const getPartnerBranchList = (item) => {
      if (item.branchUseYn == "N") return null;

      const isHeadquarter =
        item.branchUseYn == "Y" && item.headOfficeManagerYn == "Y";
      const isPartner = item.seqPartner == seqPartner;
      const parentSeqPartner = item.seqPartner;
      const prefix = isHeadquarter
        ? [
            {
              seqPartnerBranch: 0,
              partnerName: "지점 전체",
            },
          ]
        : [];

      const li = []
        .concat(prefix, item.partnerBranches || [])
        .map((item, index) => {
          const getClassName = () => {
            const classList = [];
            if (isPartner && item.seqPartnerBranch == seqPartnerBranch)
              classList.push("focus");
            if (!index && !item.seqPartnerBranch) classList.push("all");
            if (isMainCenter(parentSeqPartner, item.seqPartnerBranch))
              classList.push("main");
            return classList.join(" ");
          };
          return (
            <li key={item.seqPartnerBranch} className={getClassName()}>
              <a
                onClick={() =>
                  eventHandler.change(parentSeqPartner, item.seqPartnerBranch)
                }
              >
                {item.partnerName || item.branchName || NO_NAME}
              </a>
            </li>
          );
        });
      return <ul>{li}</ul>;
    };
    // 파트너 목록
    const getPartnerList = () => {
      const li = [];
      (partnerInfo.partnerList || []).forEach((item) => {
        const isBranch = item.branchUseYn == "Y";
        const isHeadquarter = item.headOfficeManagerYn == "Y";
        const partnerImage = item.imageUrl ? item.imageUrl : iconPartner;
        const branchItem = (item.branchList || [])[0] || {};
        const branchType = isBranch ? (isHeadquarter ? 1 : 2) : 0;

        const getClassName = () => {
          const classList = [];
          const isFocus = !isBranch && item.seqPartner == seqPartner;
          if (isFocus) classList.push("focus");

          if (!isBranch && isMainCenter(item.seqPartner, 0))
            classList.push("main");
          return classList.join(" ");
        };
        const getEventInfo = () => {
          const seqPartner = item.seqPartner;
          const seqPartnerBranch =
            branchType == 2 ? branchItem.seqPartnerBranch : 0;
          return !branchType
            ? () => eventHandler.change(seqPartner, seqPartnerBranch)
            : null;
        };
        li.push(
          <li key={item.seqPartner} className={getClassName()}>
            <a onClick={getEventInfo()}>
              <img src={partnerImage} />
              <span>{item.partnerName || NO_NAME}</span>
            </a>
            {getPartnerBranchList(item)}
          </li>
        );
      });
      return <ul>{li}</ul>;
    };

    return (
      <Wrapper
        color={color}
        className={isHome ? "home" : null}
        isOneBranch={partnerInfo.isOneBranch}
      >
        <div
          className="title"
          onClick={partnerInfo.isOneBranch ? null : eventHandler.open}
        >
          <h2>{getPartnerName()}</h2>
          {!hideFoldIcon && <FoldIcon />}
        </div>
        <StyledPopup
          ref={popupRef}
          className={isAll ? "all" : null}
          open={visible}
          onClose={setVisible}
          onRender={eventHandler.render}
        >
          <div className="top">
            <h3>센터 선택</h3>
            <a onClick={eventHandler.close}></a>
          </div>
          <div className="middle">{getPartnerList()}</div>
          <div className="bottom">
            <a onClick={eventHandler.setting}>
              <p>
                <b>주 관리 센터</b> 설정하기
              </p>
            </a>
          </div>
        </StyledPopup>
      </Wrapper>
    );
  };
  return render();
};

const Wrapper = styled.div`
  & {
    display: inline-flex;
    align-items: center;
    padding-right: 1.25em;

    & .title {
      display: flex;
      align-items: center;
      max-width: 60vw;

      & > h2 {
        color: ${(props) => props.color};
        line-height: 24px;
        font-size: 18px;
        font-weight: 700;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
      }

      & > .FoldIcon {
        margin-left: 6px;

        & > svg > path {
          stroke: ${(props) => props.color};
        }
      }
    }
  }

  &.home {
    display: block;
    padding: 16px;
    height: 54px;
    background: ${(props) =>
      props.isOneBranch
        ? `#083ea9`
        : `#083ea9 url(${iconUpDown}) no-repeat center right 16px`};
    border-radius: 12px;
    font-size: 18px;
    color: white;
  }
`;

const StyledPopup = styled(Popup)`
  & > div {
    padding-bottom: 15px;
  }
  .top {
    position: relative;
  }
  .top a {
    position: absolute;
    right: 0;
    top: 0;
    width: 24px;
    height: 24px;
    background: url(${iconClose}) no-repeat center center / 0.85em;
  }

  .middle {
    margin: 0 -24px;
    max-height: 50vh;
    font-weight: 600;
    overflow-y: auto;
  }
  .middle > ul {
    padding: 0 24px;
  }

  .middle ul {
    display: flex;
    flex-wrap: wrap;
  }
  .middle ul li {
    width: 100%;
  }
  .middle ul li a {
    display: flex;
    align-items: center;
    padding: 6px 0;
  }
  .middle ul li a img {
    margin-right: 10px;
    width: 40px;
    height: 40px;
    border-radius: 100%;
  }
  .middle ul li li a {
    padding: 12px;
  }
  .middle ul li.disabled span {
    opacity: 0.33;
  }
  .middle ul li.focus > a {
    background: url(${iconCheck}) no-repeat right center / 1em;
    font-weight: bold;
    color: var(--blue);
  }
  .middle ul li.main a:after {
    content: "";
    display: inline-flex;
    margin-left: 6px;
    width: 20px;
    height: 20px;
    background: url(${iconFlag}) no-repeat center center / 20px;
  }
  .middle ul li.all {
    display: none;
  }
  .middle ul li.all a:before {
    content: "전체";
    display: inline-flex;
    margin-right: 6px;
    padding: 2px 7px;
    background-color: var(--blue);
    border-radius: 6px;
    font-size: 12px;
    color: white;
  }
  &.all .middle ul li.all {
    display: block;
  }

  .middle ul ul {
    position: relative;
    padding-left: 38px;
  }
  .middle ul ul:before {
    content: "";
    position: absolute;
    left: 20px;
    top: 10px;
    bottom: 10px;
    border-right: 2px solid #f0f3f9;
  }
  .middle ul ul li {
    order: 1;
  }
  .middle ul ul li.disabled {
    order: 2;
  }

  .bottom {
  }
  .bottom a {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px 15px;
    background-color: #f2f5fe;
    border-radius: 6px;
    font-size: var(--14px);
  }
  .bottom a:after {
    content: "";
    width: 24px;
    height: 24px;
    background: url(${iconNext}) no-repeat center right / 8px;
    opacity: 0.66;
  }
  .bottom a p {
    display: inline-flex;
    align-items: center;
  }
  .bottom a p:before {
    content: "";
    display: inline-flex;
    margin-right: 6px;
    width: 20px;
    height: 20px;
    background: url(${iconFlag}) no-repeat center center / 20px;
  }
  .bottom a p b {
    margin-right: 0.25em;
    font-weight: 600;
    color: var(--blue);
  }
`;

export default Branch;
